module.exports = __webpack_public_path__ + "front/img/36.abb39722.png";